import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  BASE_IMAGES_URL,
  converDateIntoLocalWithOutFormat,
  maxLengthObjectFc,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
import moment from "moment";
import Lightbox from "react-image-lightbox";
import { getExtension } from "BaseFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { DropdownButton, Dropdown } from "react-bootstrap";

/*** Import Actions ***/
import {
  fetchSupportChatDetails,
  sentMessage,
  uploadMediaLarge,
} from "SupportChatAction";
import AddUserDialog from "../../users/components/dashboard-add-user";
import {
  editDashboardUser,
  fetchUsersCategory,
  sendWelcomeMail,
  allowAppAccess,
} from "DashboardUserAction";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchAllSponsors } from "ActionsSponsors";
import { fetchAllExhibitors } from "ActionsExhibitors";
import { fetchFeature } from "GeneralTabAction";
import { fetchUserInterests } from "ActionsMessage";
import ManageUsersGroup from "ManageUsersGroup";
let oldData = 0;
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/* All doc type extensions */
const docTypeExtArr = ["doc", "docm", "docx"];
const pdfTypeExtArr = ["pdf"];
const excelTypeExtArr = ["csv", "xls", "xlsx"];
const zipTypeExtArr = ["rar", "zip"];

const fileExtArr = [
  "doc",
  "docm",
  "docx",
  "pdf",
  "csv",
  "xls",
  "xlsx",
  "rar",
  "zip",
];
const videoExtArr = ["mp4", "mov", "wmv", "avi", "mkv", "mpeg-2", "webm"];
const imageExtArr = ["jpeg", "jpg", "png", "gif", "tiff", "psd", "ai"];
const maxSizeMb = 200;
const fileTxtReplace = "eventify/supportchat/";
const styledownload = {
  top: "5px",
  position: "absolute",
  right: "70px",
  cursor: "pointer",
  width: "25px",
  height: "26px",
  backgroundColor: "#fff",
  paddingTop: "1px",
  paddingLeft: "3px",
  textAlign: "center",
  borderRadius: "15%",
};
var MAXLENOBJ = {};

class SupportChatView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      btnLoading: false,
      desc: LocaleStrings.content_text_loading_chats,
      isPhotoOpen: false,
      IMAGES: [],
      photoIndex: 0,
      message: "",
      uploadedMedia: {},
      firstTime: true,
      scrollHeight: 0,
      scrollTop: 0,
      clientHeight: 0,
      sentmailloading: false,
      allowingaccess: false,
      charLeft: 0,
      charLeftText: "",
    };

    this.dummyDivRef = React.createRef();
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchAllSponsors(this.props.session);
    this.props.fetchAllExhibitors(this.props.session);
    this.props.fetchFeature(this.props.session);
    this.props.fetchUserInterests(this.props.session);

    this.props.fetchSupportChatDetails(
      this.props.session,
      this.props.selectedUserEmail,
      (callback) => {
        this.setState({ loading: false });
        this.scrollToBottom();
        this.setState({ firstTime: false });
      }
    );

    this.interval = setInterval(() => {
      this.props.fetchSupportChatDetails(
        this.props.session,
        this.props.selectedUserEmail,
        (callback) => {
          this.setState({ loading: false });

          if (parseInt(oldData) !== this.props.chatthreadDetails.length) {
            oldData = this.props.chatthreadDetails.length;

            if (
              parseInt(this.state.scrollTop) +
                parseInt(this.state.clientHeight) ===
              parseInt(this.state.scrollHeight)
            ) {
              this.scrollToBottom();
            }
          }
        }
      );
    }, 10000);

    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    this.setState({ charLeft: MAXLENOBJ.message });
    let text = "0/" + MAXLENOBJ.message;
    this.setState({ charLeftText: text });
  }

  componentWillUnmount() {
    this.setState({
      loading: true,
      btnLoading: false,
      desc: LocaleStrings.content_text_loading_chats,
      isPhotoOpen: false,
      IMAGES: [],
      photoIndex: 0,
      message: "",
      uploadedMedia: {},
      firstTime: true,
      scrollHeight: 0,
      scrollTop: 0,
      clientHeight: 0,
      sentmailloading: false,
      allowingaccess: false,
      charLeft: 0,
      charLeftText: "",
    });
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps) {
    /* When we change chat user below code invokes */
    if (prevProps.selectedUserEmail !== this.props.selectedUserEmail) {
      // Reinitialize the scroll height and width
      this.setState({
        loading: true,
        scrollHeight: 0,
        scrollTop: 0,
        clientHeight: 0,
      });
      this.props.fetchSupportChatDetails(
        this.props.session,
        this.props.selectedUserEmail,
        (callback) => {
          this.setState({ loading: false });
          this.scrollToBottom();
        }
      );

      let text = "0/" + MAXLENOBJ.message;
      this.setState({ charLeftText: text });
      this.setState({ message: "" });
      document.getElementById("message").value = "";
    }
  }

  getFileType(filename) {
    if (_.indexOf(docTypeExtArr, getExtension(filename)) !== -1) {
      return "doc";
    } else if (_.indexOf(pdfTypeExtArr, getExtension(filename)) !== -1) {
      return "pdf";
    } else if (_.indexOf(excelTypeExtArr, getExtension(filename)) !== -1) {
      return "excel";
    } else if (_.indexOf(zipTypeExtArr, getExtension(filename)) !== -1) {
      return "zip";
    } else {
      return "files";
    }
  }

  textToNameInit(value, separator) {
    // Ex - xx.yy@g.com -> XG
    let textToReturn = "";
    if (value && separator) {
      textToReturn = _.replace(
        _.upperCase(
          _.split(value, separator, 2)[0][0] +
            _.split(value, separator, 2)[1][0]
        ),
        " ",
        ""
      );
    }
    return textToReturn;
  }

  renderLoader = () => {
    //Arrow function for renderLoader
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  showtime(senton) {
    var now = moment().format("YYYY-MM-DD");
    var chatdatetime = converDateIntoLocalWithOutFormat(senton);
    var chatdate = moment(chatdatetime).format("YYYY-MM-DD");
    var chattime = moment(chatdatetime).format("HH:mm");
    var a = moment(now);
    var b = moment(chatdate);
    var diffdays = a.diff(b, "days");

    var showtime =
      diffdays === 1
        ? LocaleStrings.yesterday
        : diffdays > 1
        ? moment(b).format("DD/MM/YYYY") + " " + chattime
        : chattime;

    return showtime;
  }

  scrollToBottom = () => {
    this.dummyDivRef.current.scrollIntoView({
      // behavior: 'smooth',
      block: "end",
      inline: "nearest",
    });
  };

  handelMediaFile(path) {
    var photo = [path];
    this.setState({ IMAGES: photo });
    this.setState({ photoIndex: 0 });
    this.setState({ isPhotoOpen: true });
  }

  handelDownloadFile(filepath) {
    if (filepath !== null && filepath !== "null" && filepath !== "") {
      window.open(filepath);
    }
  }

  handleInput(e) {
    let value = e.target.value;
    let { charLeft } = this.state;
    this.setState({ message: value });

    if (value !== null && value !== "null") {
      let val = charLeft - value.length;
      let txt = val + "/" + charLeft;
      this.setState({ charLeftText: txt });
    }
  }

  /* Support Chat Details */
  renderChatDetails() {
    let eventIconPreviewUrl = "";
    let { eventicon } = this.props.brandingData;
    let { selectedUserEmail, chatthreadDetails, user } = this.props;

    if (eventicon) {
      eventIconPreviewUrl = `${BASE_IMAGES_URL}/${eventicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    return _.map(chatthreadDetails, (item, index) => {
      let name = this.textToNameInit(
        item.isadminsent === 0 ? item.useremail : user.email,
        "@"
      );
      let email =
        item.useremail !== "" &&
        item.useremail !== null &&
        item.useremail !== "null"
          ? item.useremail.length > 30
            ? item.useremail.substring(1, 30) + "..."
            : item.useremail
          : "";

      return (
        <div>
          <div style={{ padding: 20, paddingBottom: 0 }} key={index}>
            {item.isadminsent === 0 ? (
              /*** USER SENT ***/
              <div className="row">
                <div className="col-sm-2 col-lg-1">
                  <div className="supportchat-user-img align-items-center">
                    {name}.
                  </div>
                </div>
                <div className="col-sm-10 col-lg-11" align="left">
                  {item.chattype === "text" ? (
                    <div className="px-6">
                      <p className="receive-chat">{item.message}</p>
                    </div>
                  ) : item.chattype === "image" ? (
                    <div
                      className="receive-div-chat-img"
                      style={{
                        height: 100,
                        width: 100,
                        cursor: "pointer",
                        position: "relative",
                      }}
                    >
                      <img
                        height="80"
                        width="80"
                        className="chat-img"
                        src={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                        alt="media"
                        onClick={() =>
                          this.handelMediaFile(
                            `${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`
                          )
                        }
                      />
                      {/* Downlaod Button {USER side}*/}
                      <div
                        className="vcenter styledownload"
                        style={styledownload}
                      >
                        <a
                          href={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <i className="fa fa-download i-custom-ms" />
                        </a>
                      </div>
                    </div>
                  ) : item.chattype === "file" ? (
                    <div className="p-6">
                      <p
                        className="receive-chat pointer"
                        onClick={() =>
                          this.handelDownloadFile(
                            `${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`
                          )
                        }
                      >
                        {"📁 File - " +
                          _.replace(item.message, fileTxtReplace, "")}
                      </p>
                    </div>
                  ) : item.chattype === "video" ? (
                    <video width="400" controls className="receive-video">
                      <source
                        src={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                        type="video/mp4"
                      />
                      Your browser does not support HTML video.
                    </video>
                  ) : (
                    ""
                  )}
                  <div>{this.showtime(item.senton)}</div>
                </div>
              </div>
            ) : (
              /*** ADMIN SENT ***/
              <div className="row">
                <div className="col-sm-10 col-lg-11" align="right">
                  {item.chattype === "text" ? (
                    <div className="px-6">
                      <p className="sent-chat">{item.message}</p>
                    </div>
                  ) : item.chattype === "image" ? (
                    <div
                      className="sent-div-chat-img"
                      style={{
                        height: 100,
                        width: 100,
                        cursor: "pointer",
                        position: "relative",
                      }}
                    >
                      <img
                        height="80"
                        width="80"
                        className="chat-img"
                        src={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                        alt="media"
                        onClick={() =>
                          this.handelMediaFile(
                            `${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`
                          )
                        }
                      />
                      {/* Downlaod Button {ADMIN Side}*/}
                      <div
                        className="vcenter styledownload"
                        style={styledownload}
                      >
                        <a
                          href={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <i className="fa fa-download i-custom-ms" />
                        </a>
                      </div>
                    </div>
                  ) : item.chattype === "file" ? (
                    this.getFileType(item.message) === "file" ? (
                      <div className="p-6">
                        <p
                          className="sent-chat pointer"
                          onClick={() =>
                            this.handelDownloadFile(
                              `${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`
                            )
                          }
                        >
                          {"📁 File - " +
                            _.replace(item.message, fileTxtReplace, "")}
                        </p>
                      </div>
                    ) : (
                      <div
                        className="sent-div-chat-img"
                        style={{
                          height: 100,
                          width: 100,
                          cursor: "pointer",
                          position: "relative",
                        }}
                      >
                        <img
                          height="80"
                          width="80"
                          className="chat-img"
                          src={`../../style/images/support-chat-icons/${this.getFileType(
                            item.message
                          )}.png`}
                          alt="media"
                          onClick={() =>
                            this.handelDownloadFile(
                              `${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`
                            )
                          }
                        />
                        {/* Downlaod Button {ADMIN Side}*/}
                        <div
                          className="vcenter styledownload"
                          style={styledownload}
                        >
                          <a
                            href={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                            target="_blank"
                            rel="noreferrer"
                            download
                          >
                            <i className="fa fa-download i-custom-ms" />
                          </a>
                        </div>
                      </div>
                    )
                  ) : item.chattype === "video" ? (
                    <video width="400" controls className="sent-video">
                      <source
                        src={`${BASE_IMAGES_URL}/${item.message}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`}
                        type="video/mp4"
                      />
                      Your browser does not support HTML video.
                    </video>
                  ) : (
                    ""
                  )}
                  <div>{this.showtime(item.senton)}</div>
                </div>
                <div className="col-sm-2 col-lg-1" style={{ paddingLeft: 0 }}>
                  {eventIconPreviewUrl ? (
                    <img
                      className="supportchat-appicon-img align-items-center"
                      src={eventIconPreviewUrl}
                      alt="eventicon"
                    />
                  ) : (
                    <div className="supportchat-user-img align-items-center">
                      {name}.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    });
  }

  _handleSelect(event) {
    this.setState({ message: "" });
    this.setState({ charLeftText: "" });

    let filearr = [];
    const reader = new FileReader(); // Define reader
    let file = event.target.files[0]; // Take Selected file

    /*** SIZE VALIDATION ***/
    if (file.size / 1024 / 1024 > maxSizeMb) {
      this.props.showError(
        LocaleStrings.support_chat_file_limit + maxSizeMb + " MB"
      );
      return false;
    }

    /*** File Type VALIDATION ***/
    if (file) {
      //let ext = _.trim(_.lowerCase(file.name.split(".").pop()));
      let ext = _.trim(file.name.split(".").pop().toLowerCase());
      if (
        _.indexOf(_.union(fileExtArr, videoExtArr, imageExtArr), ext) === -1
      ) {
        this.props.showError(LocaleStrings.validation_file_type_invalid);
        return false;
      }
    }

    reader.readAsArrayBuffer(file); // Read the file
    reader.onload = (e) => {
      file.url = e.target.result;
      filearr.push(file);
    };
    this.setState({ uploadedMedia: filearr });
  }

  sendMessage(e) {
    let { selectedUserEmail, session } = this.props;
    let { message, uploadedMedia } = this.state;
    let medianame = "";
    let ext = "";
    let chattypeVal = "text";

    if (
      ((message === "") | (message === "null") || message === null) &&
      _.isEmpty(uploadedMedia)
    ) {
      return false;
    }

    this.setState({ btnLoading: true });

    if (!_.isEmpty(uploadedMedia)) {
      //ext = _.trim(_.lowerCase(uploadedMedia[0].name.split(".").pop()));
      ext = _.trim(uploadedMedia[0].name.split(".").pop().toLowerCase());
      medianame = "IMG_" + moment().unix() + "." + ext;
      message = "eventify/" + session.eventid + "/supportchat/" + medianame;
    }

    if (!_.isEmpty(uploadedMedia)) {
      if (_.indexOf(fileExtArr, ext) > -1) {
        chattypeVal = "file";
      } else if (_.indexOf(videoExtArr, ext) > -1) {
        chattypeVal = "video";
      } else if (_.indexOf(imageExtArr, ext) > -1) {
        chattypeVal = "image";
      } else {
        // No need
      }
    }

    let value = {
      useremail: _.trim(selectedUserEmail),
      eventid: session.eventid,
      adminuserid: session.userid,
      chattype: chattypeVal,
      message: message,
      unixtimestamp: moment().unix(),
      isadminsent: 1,
    };

    let uploaderCounter = 0;
    let filetobeupload = [];
    let arrPromise = [];

    _.forEach(uploadedMedia, function (value, index) {
      if (Object.keys(value).length > 0) {
        let coverJson = {
          type: value.type,
          name: medianame,
          media: value.url,
        };

        filetobeupload.push(coverJson); //
      }
    });

    let counter = filetobeupload.length;

    if (counter > 0) {
      // Imgae server first
      filetobeupload.map((item, index) => {
        arrPromise.push(
          new Promise((resolve, reject) => {
            this.props.uploadMediaLarge(
              this.props.session,
              item,
              (response) => {
                if (response.success === 0) {
                  resolve();
                } else {
                  uploaderCounter++;
                  resolve();
                }
              }
            );
          })
        );
      });

      Promise.all(arrPromise).then(() => {
        if (uploaderCounter === counter) {
          // After file upload
          this.props.sentMessage(this.props.session, value, (callback) => {
            this.setState({ btnLoading: false });
            this.setState({ uploadedMedia: {} });
            this.setState({ message: "" });
            document.getElementById("message").value = "";
            this.props.fetchSupportChatDetails(
              this.props.session,
              this.props.selectedUserEmail,
              (callback) => {
                this.scrollToBottom();
              }
            );
          });
        } else {
          alert(LocaleStrings.content_something_wrong);
        }
      });
    } else {
      this.props.sentMessage(this.props.session, value, (callback) => {
        this.setState({ btnLoading: false });
        this.setState({ uploadedMedia: {} });
        this.setState({ message: "" });
        document.getElementById("message").value = "";
        this.props.fetchSupportChatDetails(
          this.props.session,
          this.props.selectedUserEmail,
          (callback) => {
            this.scrollToBottom();
          }
        );
      });
    }
  }

  handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    this.setState({ scrollHeight: e.target.scrollHeight });
    this.setState({ scrollTop: e.target.scrollTop });
    this.setState({ clientHeight: e.target.clientHeight });
  };

  /*** Scroll TO bottom animated ***/
  animatedScrollBottom(e) {
    this.dummyDivRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  }

  userAdditionCallback = () => {};

  /*** Edit User ***/
  editUser(userObject) {
    this.props.editDashboardUser(userObject);
  }

  loginUser = () => {
    this.setState({ allowingaccess: true });
    this.props.allowAppAccess(
      this.props.session,
      { email: this.props.userDetailsWithEmail.email },
      (response) => {
        this.setState({ allowingaccess: false });
        if (response.success === 0) {
          this.props.showError(response.message);
        } else {
          this.props.showSuccess(
            LocaleStrings.user_message_user_access_allowed
          );
        }
      }
    );
  };

  /*** Sent Welcome Mail ***/
  sendMail = (e) => {
    e.preventDefault();
    this.setState({ sentmailloading: true });
    var { email } = this.props.userDetailsWithEmail;
    this.props.sendWelcomeMail(
      this.props.session,
      { email: email },
      (response) => {
        this.setState({ sentmailloading: false });
        if (response.success === 1) {
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else if (response.success === 3) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error1
          );
        } else if (response.success === 4) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error2
          );
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  render() {
    var {
      deviceSize,
      selectedUserEmail,
      chatthreadDetails,
      userDetailsWithEmail,
    } = this.props;
    var { loading, IMAGES, photoIndex, message, uploadedMedia, charLeftText } =
      this.state;

    var imagePath1 = "../../style/images/support-chat-icons/nochats.svg";
    let name = this.textToNameInit(selectedUserEmail, "@");

    return (
      <div className="chat-conatiner" style={{ border: "1px solid #eeeeee" }}>
        <div className="d-flex modal-header chat-modal-header">
          {/* <div className="modal-title"> */}
          {/* <div className="d-flex align-items-center"> */}
          <div className="d-flex col-5 align-items-center">
            <div className="supportchat-user-div" style={{ marginLeft: 15 }}>
              {name}.
            </div>
            <div>
              <span className="ml-2 chat-custom-text6-medium-primary">
                {selectedUserEmail}
              </span>
            </div>
          </div>
          <div className="col-7 d-flex justify-content-end">
            <div
              style={{
                height: "38px",
                padding: "0 12px 0 0",
                // margin: "5px 20px",
              }}
            >
              {this.state.loading ? (
                ""
              ) : !_.isEmpty(userDetailsWithEmail) ? (
                <div>
                  {}
                  <div
                    style={{ display: "flex" }}
                    className="cust-inline-block"
                  >
                    <Button
                      className="btn btn-custom-table-blue w-full- mr-3"
                      type="button"
                      onClick={() => this.editUser(userDetailsWithEmail)}
                    >
                      <img
                        className="i-custom-normal"
                        src="../../style/images/custom-icons/edit.svg"
                        alt="edit"
                      />
                    </Button>
                    <Button
                      className="btn btn-custom-table-blue mr-3"
                      loading={this.state.allowingaccess}
                      type="button"
                      onClick={
                        userDetailsWithEmail.isactive == 1 &&
                        userDetailsWithEmail.userwaitlistmode == 0
                          ? this.loginUser
                          : null
                      }
                      disabled={
                        userDetailsWithEmail.isactive == 1 &&
                        userDetailsWithEmail.userwaitlistmode == 0
                          ? false
                          : true
                      }
                    >
                      {LocaleStrings.button_allow_app_access}
                    </Button>
                    <Button
                      className="btn btn-custom-table-blue"
                      loading={this.state.sentmailloading}
                      type="button"
                      onClick={
                        userDetailsWithEmail.isactive == 1
                          ? this.sendMail
                          : null
                      }
                      disabled={
                        userDetailsWithEmail.isactive == 1 ? false : true
                      }
                    >
                      {LocaleStrings.button_send_welcome_email}
                    </Button>
                  </div>

                  <div className="dropdown-btn-container">
                    <DropdownButton
                      style={{ marginLeft: 94, paddingRight: 0 }}
                      className="dropdown-white-btn cust-dropdown"
                      title={LocaleStrings.user_table_list_action}
                      key="1"
                      id="dropdown-basic-1"
                      nocaret="true"
                    >
                      <Dropdown.Item eventKey="edit">
                        <Button
                          className="btn btn-custom-table-blue w-full"
                          type="button"
                          onClick={() => this.editUser(userDetailsWithEmail)}
                        >
                          {LocaleStrings.support_edit_user_btn}
                        </Button>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Button
                          className="btn btn-custom-table-blue w-full"
                          loading={this.state.allowingaccess}
                          type="button"
                          onClick={
                            userDetailsWithEmail.isactive == 1 &&
                            userDetailsWithEmail.userwaitlistmode == 0
                              ? this.loginUser
                              : null
                          }
                          disabled={
                            userDetailsWithEmail.isactive == 1 &&
                            userDetailsWithEmail.userwaitlistmode == 0
                              ? false
                              : true
                          }
                        >
                          {LocaleStrings.button_allow_app_access}
                        </Button>
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="view">
                        <Button
                          className="btn btn-custom-table-blue w-full"
                          loading={this.state.sentmailloading}
                          type="button"
                          onClick={
                            userDetailsWithEmail.isactive == 1
                              ? this.sendMail
                              : null
                          }
                          disabled={
                            userDetailsWithEmail.isactive == 1 ? false : true
                          }
                        >
                          {LocaleStrings.button_send_welcome_email}
                        </Button>
                      </Dropdown.Item>
                    </DropdownButton>
                  </div>
                  <div hidden>
                    <AddUserDialog
                      finishOperationsCallback={this.userAdditionCallback}
                    />
                  </div>
                  {this.props.ShowUserCategoryModal ? (
                    <ManageUsersGroup
                      finishOperationsCallback={this.userAdditionCallback}
                    />
                  ) : null}
                </div>
              ) : (
                <span className="nonreg-mail">
                  {LocaleStrings.email_is_not_registered}
                </span>
              )}
            </div>
          </div>
          {/* </div> */}
          {/* </div> */}
        </div>

        <div
          className="scrollable-content- scrollbar-hide"
          style={{
            height:
              deviceSize.height > 700
                ? deviceSize.height - 255 + 15
                : deviceSize.height - 255 + 15,
          }}
          ref={this.myRef}
          onScroll={this.handleScroll}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : _.isEmpty(chatthreadDetails) ? (
            <div className="no-content-message">
              <div>
                <img src={imagePath1} alt="" />
                <div className="no-content-text">Say Hello</div>
              </div>
            </div>
          ) : (
            <div className="chat-conatiner" id="chat-conatiner">
              {this.renderChatDetails()}
              <div ref={this.dummyDivRef} />
            </div>
          )}
        </div>
        <hr />
        {/* Footer Section */}
        <div
          className={classNames(
            loading ? "hidden" : "",
            "chat-footer-container"
          )}
          style={{ position: "relative" }}
        >
          <div className="attachment-button" align="center">
            <label
              htmlFor="file-upload-image"
              className="pointer"
              style={{ marginBottom: "0px" }}
            >
              <div className="btn-custom-blue ">
                <i
                  className="fa fa-plus"
                  aria-hidden="true"
                  style={{ marginTop: 5 }}
                ></i>
              </div>
              <input
                onChange={(e) => this._handleSelect(e)}
                accept="image/*,video/*,.rar,.pdf,.doc,.docx,.csv,.xls,.xlsx,.docm"
                type="file"
                id="file-upload-image"
                name="file-upload-image"
                autoComplete="off"
                style={{ display: "none" }}
              />
            </label>
          </div>
          <div className="text-box-area">
            {_.isEmpty(uploadedMedia) ? (
              <div style={{ position: "relative" }}>
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  placeholder="Type a message"
                  style={{ border: 0, height: 40 }}
                  cols={1}
                  onChange={(e) => this.handleInput(e)}
                  maxlength={MAXLENOBJ.message ? MAXLENOBJ.message : ""}
                >
                  {message}
                </textarea>
                <span id="supportchat-char-left" className="char-left">
                  {charLeftText}
                </span>
              </div>
            ) : (
              <button
                type="button"
                className="btn-custom-blue"
                onClick={(e) => this.setState({ uploadedMedia: {} })}
              >
                {uploadedMedia[0].name.length > 20
                  ? uploadedMedia[0].name.substring(1, 20) + "..."
                  : uploadedMedia[0].name}
                &nbsp;&nbsp;&nbsp; ×
              </button>
            )}
          </div>
          <div className="send-button" align="center">
            <Button
              className="btn-custom-blue"
              loading={this.state.btnLoading}
              onClick={(e) => this.sendMessage(e)}
              type="button"
            >
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </Button>
          </div>

          <div
            className={classNames(
              parseInt(this.state.scrollTop) +
                parseInt(this.state.clientHeight) ===
                parseInt(this.state.scrollHeight)
                ? "hidden"
                : "",
              "scroll-down-div"
            )}
            onClick={(e) => this.animatedScrollBottom(e)}
          >
            {/* <OverlayTrigger
              placement="left"
              overlay={
                <Tooltip style={{ marginTop: "1px" }}>
                  {LocaleStrings.supportchat_tooptip_scrolldown_text}
                </Tooltip>
              }
            >
              <i className="fa fa-arrow-down" aria-hidden="true"></i>
            </OverlayTrigger> */}

            <OverlayTrigger
              placement="left"
              overlay={
                <Tooltip style={{ marginTop: "1px" }}>
                  {LocaleStrings.supportchat_tooptip_scrolldown_text}
                </Tooltip>
              }
            >
              {({ ref, ...triggerHandler }) => (
                <>
                  <div
                    className="toolitp-btn"
                    style={{ borderColor: "#fff", height: 34 }}
                  >
                    <i className="fa fa-arrow-down" aria-hidden="true"></i>
                    <span className="tooltiptext">
                      {LocaleStrings.supportchat_tooptip_scrolldown_text}
                    </span>
                  </div>
                </>
              )}
            </OverlayTrigger>
          </div>
        </div>

        {this.state.isPhotoOpen ? (
          <Lightbox
            mainSrc={IMAGES[photoIndex]}
            nextSrc={IMAGES[(photoIndex + 1) % IMAGES.length]}
            prevSrc={IMAGES[(photoIndex + IMAGES.length - 1) % IMAGES.length]}
            onCloseRequest={() => this.setState({ isPhotoOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + IMAGES.length - 1) % IMAGES.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({ photoIndex: (photoIndex + 1) % IMAGES.length })
            }
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  /*** For Sent Mail Section ***/
  var eventData = {};
  if (state.eventData[0]) {
    eventData = state.eventData[0];
  }

  return {
    settingMenus: state.settingMenus,
    session: state.session,
    user: state.user,
    eventData,
    deviceSize: state.deviceSize,
    userDetailsWithEmail: state.userDetailsWithEmail,
    chatthreadDetails: !_.isEmpty(state.chatthreadDetails)
      ? state.chatthreadDetails
      : [],
    brandingData: state.brandingData,
    mainunreadcount: _.isEmpty(state.unreadcount)
      ? 0
      : parseInt(state.unreadcount),
    ShowUserCategoryModal: state.ShowDashboardUserCategoryModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchSupportChatDetails,
  sentMessage,
  uploadMediaLarge,
  editDashboardUser,
  fetchUsersCategory,
  fetchUserInterests,
  fetchAllSpeakers,
  fetchAllSponsors,
  fetchAllExhibitors,
  fetchFeature,
  allowAppAccess,
  sendWelcomeMail,
})(SupportChatView);
